module.exports = __webpack_public_path__ + "img/meals.3c2aa2f3.png";